import { render, staticRenderFns } from "./CardDeposito.vue?vue&type=template&id=8138df9e&"
import script from "./CardDeposito.vue?vue&type=script&lang=js&"
export * from "./CardDeposito.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports